import * as React from 'react';

function WarningIcon(props) {
  return (
    <svg width={24} height={24} viewBox='0 0 63 57' {...props}>
      <defs>
        <linearGradient
          id='prefix__a'
          x1='0%'
          x2='99.487%'
          y1='51.79%'
          y2='48.229%'>
          <stop offset='0%' stopColor='#737d84' />
          <stop offset='100%' stopColor='#737d84' />
        </linearGradient>
        <linearGradient
          id='prefix__b'
          x1='0%'
          x2='99.487%'
          y1='51.315%'
          y2='48.699%'>
          <stop offset='0%' stopColor='#737d84' />
          <stop offset='100%' stopColor='#737d84' />
        </linearGradient>
        <linearGradient
          id='prefix__c'
          x1='0%'
          x2='99.487%'
          y1='85.28%'
          y2='15.082%'>
          <stop offset='0%' stopColor='#737d84' />
          <stop offset='100%' stopColor='#737d84' />
        </linearGradient>
      </defs>
      <g fill='none' fillRule='evenodd'>
        <path
          fill='#EFF3F6'
          fillRule='nonzero'
          d='M1.612 23.61c6.387 10.26 5.457 20.616 8.536 25.562 3.08 4.945 12.387 13.56 35.134-.6s17.39-30.207 14.004-35.647C43.433-12.543-9.7 5.437 1.612 23.61z'
        />
        <path
          fill='#EFF3F6'
          fillRule='nonzero'
          d='M13.297 20.01v19.222c0 .961.787 1.748 1.748 1.748h23.591a3.494 3.494 0 003.495-3.495V20.01H13.297z'
        />
        <path
          fill='url(#prefix__a)'
          d='M.082 5.324h32.329v6.117H.082z'
          transform='translate(11.468 8.569)'
        />
        <path
          fill='url(#prefix__b)'
          d='M27.605.082H4.888L.082 5.324h32.329z'
          transform='translate(11.468 8.569)'
        />
        <path
          fill='url(#prefix__c)'
          d='M39.4 37.732a1.68 1.68 0 01-1.68 1.669H19.238a1.681 1.681 0 01-1.681-1.67c0-.315.084-.616.252-.866l9.24-15.013c.285-.484.823-.8 1.428-.8s1.143.316 1.428.8l9.24 15.013c.172.25.256.55.256.867z'
          transform='translate(11.468 8.569)'
        />
        <path
          fill='#9FACB6'
          fillRule='nonzero'
          d='M17.23 39.232V20.01h-3.933v19.222c0 .961.787 1.748 1.748 1.748h3.932a1.754 1.754 0 01-1.748-1.748z'
          opacity={0.2}
        />
        <path
          fill='#737d841'
          fillRule='nonzero'
          d='M11.55 13.893h3.932v6.117H11.55zm4.806-5.242l-4.806 5.242h3.932l4.805-5.242zM32.957 46.3c0-.316.084-.616.251-.866l8.705-14.139-.538-.874a1.653 1.653 0 00-1.428-.8c-.605 0-1.143.316-1.428.8l-9.24 15.013c-.168.25-.252.55-.252.867a1.68 1.68 0 001.68 1.669h3.933a1.68 1.68 0 01-1.683-1.67z'
          opacity={0.2}
        />
        <g fill='#9FACB6' fillRule='nonzero'>
          <path d='M20.288 50.591a2.625 2.625 0 01-2.622-2.622 2.624 2.624 0 012.622-2.621c1.445 0 2.62 1.176 2.62 2.621s-1.174 2.622-2.62 2.622zm0-3.496c-.481 0-.874.394-.874.874s.393.874.874.874c.48 0 .873-.393.873-.874a.877.877 0 00-.873-.874zM55.002 23.648l2.47-2.47 1.236 1.235-2.471 2.47zM47.895 30.752l2.47-2.47 1.236 1.235-2.471 2.47zM47.89 22.086l1.236-1.236 2.47 2.47-1.236 1.236zM55 29.209l1.236-1.236 2.471 2.472-1.235 1.235z' />
        </g>
        <path
          fill='#737d84'
          fillRule='nonzero'
          d='M49.188 49.28H30.706a2.989 2.989 0 01-2.992-2.977c0-.586.165-1.138.476-1.601l9.21-14.968c.516-.872 1.495-1.424 2.547-1.424s2.03.552 2.556 1.445l9.229 14.99c.283.42.447.972.447 1.558a2.989 2.989 0 01-2.991 2.977zm-9.241-18.349a.347.347 0 00-.3.156l-9.311 15.216c0 .192.17.356.37.356h18.482c.2 0 .37-.164.37-.356a.253.253 0 00-.03-.137l-9.27-15.056a.348.348 0 00-.311-.179z'
        />
        <path
          fill='#737d84'
          fillRule='nonzero'
          d='M38.636 34.863h2.621v6.117h-2.621zM26.404 42.29h-11.36a3.061 3.061 0 01-3.057-3.058V20.01a1.31 1.31 0 011.31-1.311h28.834c.724 0 1.31.587 1.31 1.31v5.243h-2.62V21.32H14.608v17.912c0 .238.2.437.437.437h11.359v2.621z'
        />
        <path
          fill='#737d84'
          fillRule='nonzero'
          d='M23.782 23.941h7.864v2.622h-7.864zm20.097-2.621h-32.33a1.31 1.31 0 01-1.31-1.31v-6.117c0-.723.587-1.31 1.31-1.31h32.33c.723 0 1.31.587 1.31 1.31v6.117a1.31 1.31 0 01-1.31 1.31zM12.86 18.7h29.707v-3.495H12.861V18.7z'
        />
        <path
          fill='#737d84'
          fillRule='nonzero'
          d='M42.912 14.78l-4.416-4.82H16.932l-4.416 4.818-1.932-1.772 4.805-5.242c.248-.271.6-.425.967-.425h22.717c.367 0 .718.154.966.425l4.806 5.242-1.933 1.772zm-2.965 31.005a1.313 1.313 0 01-1.311-1.31c0-.177.035-.35.105-.507.052-.157.157-.297.28-.42.473-.489 1.363-.489 1.854 0 .244.245.384.577.384.927 0 .174-.037.35-.106.506-.07.158-.158.297-.278.42a1.32 1.32 0 01-.928.384z'
        />
      </g>
    </svg>
  );
}

export default WarningIcon;
